export default "__VITE_ASSET__BOTDhS2j__"